export function handleError(error) {
    console.log(error.response.data.error);
}

export function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function saveAsFile(name, type, base64) {
    var xlsType = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
    var csvType = "data:application/octet-stream;base64,";
    var xmlType = "data:application/xml;base64,"; 
    var mediaType = "";
    switch (type) {
        case 'xls':
            mediaType = xlsType;
            break;
        case 'csv':
            mediaType = csvType;
        case 'xml':
            mediaType = xmlType;    
            break;
        default:
            break;
    }
    var a = document.createElement('a');
    a.href = mediaType + base64;
    a.download = name;
    a.textContent = '';
    document.body.appendChild(a);
    a.click();
}

